import { render, staticRenderFns } from "./landSummary.vue?vue&type=template&id=0096b26c&scoped=true"
import script from "./landSummary.vue?vue&type=script&lang=js"
export * from "./landSummary.vue?vue&type=script&lang=js"
import style0 from "./landSummary.vue?vue&type=style&index=0&id=0096b26c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096b26c",
  null
  
)

export default component.exports